import Banca, { StatusBanca, BancaUtils } from '../../../model/banca/Banca';

export enum ButtonState {
  HIDDEN = 'hidden',
  ENABLED = 'enabled',
  DISABLED = 'disabled',
  SUCCESS = 'success',
  WARNING = 'warning'
}

export interface ButtonConfig {
  state: ButtonState;
  title: string;
  icon: string;
  backgroundColor: string;
}

export const getBancaButtonConfig = (banca: Banca, buttonType: 'cancel' | 'close' | 'finalize' | 'integrate'): ButtonConfig => {
  const realStatus = BancaUtils.getRealStatusBanca(banca);
  
  switch (buttonType) {
    case 'cancel':
      if (!BancaUtils.isStatusAnteriorOuIgual(StatusBanca.CONSULTADA, realStatus)) {
        return { state: ButtonState.HIDDEN, title: '', icon: '', backgroundColor: '' };
      }
      return {
        state: ButtonState.ENABLED,
        title: 'Cancelar Banca',
        icon: '✕',
        backgroundColor: '#f8d7da'
      };

    case 'close':
      if (!BancaUtils.isBancaFechavel(banca)) {
        return { state: ButtonState.HIDDEN, title: '', icon: '', backgroundColor: '' };
      }
      return {
        state: ButtonState.ENABLED,
        title: 'Fechar Banca',
        icon: '⊖',
        backgroundColor: '#d4edda'
      };

    case 'finalize':
      if (banca.status !== StatusBanca.INTEGRACAO) {
        return { state: ButtonState.HIDDEN, title: '', icon: '', backgroundColor: '' };
      }
      if (!banca.finalizavel) {
        return {
          state: ButtonState.DISABLED,
          title: 'Aguardando dados para finalização',
          icon: '⏳',
          backgroundColor: '#e9ecef'
        };
      }
      return {
        state: ButtonState.ENABLED,
        title: 'Finalizar Banca',
        icon: '✓',
        backgroundColor: '#66cc99'
      };

    case 'integrate':
      if (banca.status !== StatusBanca.INTEGRACAO || banca.finalizavel) {
        return { state: ButtonState.HIDDEN, title: '', icon: '', backgroundColor: '' };
      }
      return {
        state: ButtonState.WARNING,
        title: 'Integração em andamento',
        icon: '⚠',
        backgroundColor: '#fff3cd'
      };

    default:
      return { state: ButtonState.HIDDEN, title: '', icon: '', backgroundColor: '' };
  }
};

export const shouldShowColumn = (bancas: Banca[], buttonType: 'cancel' | 'close' | 'finalize' | 'integrate'): boolean => {
  return bancas.some(banca => getBancaButtonConfig(banca, buttonType).state !== ButtonState.HIDDEN);
};